import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export default function HomeHero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/?q=${encodeURIComponent(kw)}`);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20slate%20blue%20newsroom%20data%20grid%20with%20orange%20accent%20light%20streaks%2C%20minimal%20geometric%20editorial%20illustration%2C%20cinematic%20moody%20atmosphere%2C%20soft%20gradient%20texture&width=1920&height=800&seq=hero-main-01&orientation=landscape"
          alt="黑料官网焦点信息聚合背景图"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-900/60" />
      </div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-label text-accent-200">
          <i className="ri-sparkling-2-line" />
          权威黑料信息聚合与深度解析
        </span>
        <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          黑料官网
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-7 text-background-200 md:text-base">
          汇总最新动态、社会热点与多维度深度内容，覆盖社会热点、娱乐内幕、财经风云、网络揭秘等分类，
          帮助您及时了解真实内幕与社会热点。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 flex w-full max-w-xl items-center rounded-lg border border-background-50/20 bg-background-50/10 p-1.5 backdrop-blur"
          role="search"
        >
          <i className="ri-search-line ml-2 text-lg text-background-200" />
          <input
            type="text"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="输入关键词，快速查找相关黑料信息"
            className="ml-2 w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-300"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-label font-medium text-accent-950 transition-colors hover:bg-accent-400 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="mt-10 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { value: "36", label: "收录条目" },
            { value: "6", label: "内容分类" },
            { value: "每日", label: "更新频率" },
          ].map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-50/15 bg-background-50/5 px-4 py-3">
              <p className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}